import { render, staticRenderFns } from "./footer-contacts.vue?vue&type=template&id=5fd09e51"
import script from "./footer-contacts.vue?vue&type=script&lang=ts"
export * from "./footer-contacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports